<h2 mat-dialog-title tabindex="0" class="narrow" data-test-id="create-verfahren-dialog">Verfahren anlegen (Neueintragung)</h2>
<mat-dialog-content [formGroup]="form">
	<mat-form-field appearance="outline">
		<mat-label>Register</mat-label>
		<mat-select class="registerSelect" [formControl]="registerControl" data-test-id="select-register">
			@for (register of registerSelectionList; track register) {
				<mat-option [value]="register" [attr.data-test-id]="'value-' + register?.toLowerCase()" class="focus-inwards-dark">
					{{ register }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
	<schir-int-client-one-value-editor
			type="number" [stepsize]="1" label="Blattnummer" [formGroup]="form" [fieldControl]="blattnummerControl"
			[readonly]="blattnummerGenerieren" data-test-id="blattnummer-input"
	/>
</mat-dialog-content>
<mat-dialog-actions>
	<button mat-stroked-button (click)="onCancel()" class="focus-inwards-dark" data-test-id="cancel-button">
		Abbrechen
	</button>
	<button mat-flat-button (click)="onSave()" [disabled]="!isValid()" color="primary" class="icon-right focus-inwards-dark" data-test-id="speichern-button">
		Speichern
	</button>
</mat-dialog-actions>
